export const SECONDARY_CHANNEL_STORAGE_KEY = "secondaryChannel";
export const MARKETPLACE_STORAGE_KEY = "Marketplace";
export const CHANNEL_STORAGE_KEY = "channel";
